import { useTranslation } from 'react-i18next';
import { toast } from "react-toastify";
import {useEffect, useState} from "react";
import {GetConfigByName} from "../../../../../reduxToolkit/authentication/AuthenticatonApi";
import {SYSTEM_CONFIG_LIST} from "../../../Setting/Model/SettingConfigModel";
import {useDispatch} from "react-redux";
import copy from "copy-to-clipboard";
import { getDateFormat, getTimeFormat } from '../../../../../Apis/functions';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 * CopyInvitationLinkApp
 *
 * }}
 */

const CopyInvitationLinkApp = ({ itemSelected, setShow }) => {
    const dispatch = useDispatch(); // Redux dispatch function
    const { t } = useTranslation(); // Translation hook for multilingual support
    const [buttonText, setButtonText] = useState("click_to_copy"); // Button label state
    const [copySecret, setCopySecret] = useState(false);
    const [link, setLink] = useState(""); // Button label state

    useEffect(() => {
        dispatch(GetConfigByName(SYSTEM_CONFIG_LIST.environmentUrl)).then(({ payload: { data: { data } } }) => {
            setLink(data + "invitation-details/" + itemSelected?.id);
        });
    }, []);

/**
 * Builds the full invitation message to be copied to the clipboard.
 *
 * This function formats the visit date and time according to the current locale,
 * then injects all dynamic invitation data into the multilingual.
 * 
 * @returns {string} Fully formatted invitation message ready to be copied.
 */
const buildCopyMessage = () => {
    const formattedDate = getDateFormat(itemSelected?.startDate, false);
    const formattedTime = getTimeFormat(itemSelected?.startDate);

    return t('invitation_copy_message', {
        visitorName: `${itemSelected?.visitorFullName}`,
        hostName: `${itemSelected?.hostName}`,
        visitDate: `${formattedDate}`,
        visitTime: `${formattedTime}`,
        zoneName: `${itemSelected?.zoneName}`,
        inviteLink: `${link}`,
        interpolation: { escapeValue: false },
    });
};

    /**
     * Handles copying the secret key to the clipboard.
     * If already copied, hides the modal and triggers the onHide callback.
     */
    const handleConfirm = () => {
        if (copySecret) {
            setCopySecret(false);
            setShow(false);
            return;
        }
        const fullMessage = buildCopyMessage();
        const success = copy(fullMessage);
        if(success){
            toast.success(t("text_copied_successfully"));
            setButtonText("close")
            setCopySecret(true);
        }else{
            toast.success(t("failed_to_copy_text"));
        }
    }

    /**
     * Hides the modal and resets relevant state.
     */
    const onHideModal = () => {
        setShow(false);
        setCopySecret(false);
        setButtonText("click_to_copy");
    }

    // Return functions and states to be used by the component
    return {
        t,
        buttonText,
        link,
        handleConfirm,
        onHideModal
    }
}

export default CopyInvitationLinkApp;
